import { render, staticRenderFns } from "./NewExtra.vue?vue&type=template&id=6e267d55&"
import script from "./NewExtra.vue?vue&type=script&lang=js&"
export * from "./NewExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports